/**
 * @generated SignedSource<<06145b3f7cb51f27c9fb6f21fecc30da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodosList_workspace$data = {
  readonly activeTodos: ReadonlyArray<{
    readonly body: string | null;
    readonly createdAtDate: {
      readonly isoString: string;
    };
    readonly expireAtDate: {
      readonly isoString: string;
    } | null;
    readonly id: string;
    readonly priorityOrder: number;
    readonly publishedAtDate: {
      readonly isoString: string;
    } | null;
    readonly scheduledPublishAt: {
      readonly isoString: string;
    } | null;
    readonly status: WorkspaceTodoStatus;
    readonly title: string;
    readonly todoCount: number;
    readonly todosCompletedCount: number;
    readonly topic: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItem_todo">;
  }>;
  readonly id: string;
  readonly topics: ReadonlyArray<{
    readonly __typename: "OrgTopic";
  }> | null;
  readonly " $fragmentType": "WorkspaceTodosList_workspace";
};
export type WorkspaceTodosList_workspace$key = {
  readonly " $data"?: WorkspaceTodosList_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodosList_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodosList_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoWorkspace",
      "kind": "LinkedField",
      "name": "activeTodos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "createdAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "scheduledPublishAt",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "publishedAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnzonedDate",
          "kind": "LinkedField",
          "name": "expireAtDate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgTopic",
          "kind": "LinkedField",
          "name": "topic",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "todoCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "todosCompletedCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priorityOrder",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceTodoListItem_todo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "63e10558d70440c93f6fdecccb0fed86";

export default node;
